import { CHANGE_USER, ISecurityState, ChangeSecurityUser } from '../actions/actions';

const initialState: ISecurityState = {
  token: '',
  user: '',
  email: ''
}

const securityReducer = (state = initialState, action: ChangeSecurityUser): ISecurityState => {
    switch (action.type) {
      case CHANGE_USER:
        console.log('reducer-state', state);
        const x = {
          ...state,
          token: action.payload.token,
          user: action.payload.user,
          email: action.payload.email
        };
        console.log('x', x);
        return x
      default:
        return state;
    }
}

export default securityReducer;